<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Amazon</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<CatalogActions platform="amazon" :fallback-marketplaces="marketplaceFilterOptions" @applied="getDataFromApi()" />
							<v-toolbar-items shift>
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
							</v-toolbar-items>
							<template v-slot:extension>
								<MarketplaceTabs platform="amazon" />
							</template>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.marketplace"
										:items="marketplaceFilterOptions"
										label="Marketplace"
										item-text="text"
										item-value="value"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.status"
										:items="statusFilterOptions"
										label="Status"
										item-text="text"
										item-value="value"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni inserzione diventa una card chiave/valore con i campi modificabili -->
								<tbody v-if="mobileCards" class="amazon-cards">
									<tr v-for="(item, index) in items" :key="index">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.item || 'Prodotto'" :fields="campiCard(item)" :image="createImage(item)" :image-fallback="imagePlaceholder">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-sync" @click="chiediEliminaSync(item)">
																<v-list-item-title>Elimina sincronizzazione </v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteMarketplace(item)">
																<v-list-item-title>Elimina da cms/marketplace </v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-edit" v-if="item.status === 'Confirmed'" @click="editConfirmedMarketplace(item)">
																<v-list-item-title>Modifica su cms/marketplace </v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-detail" @click="editItem(item)">
																<v-list-item-title>Visualizza dettaglio prodotto </v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center mb-2">
														<img :src="getImageMarketplace(item.platform)" :alt="item.platform" style="width: 30px; margin-right: 5px" />
														<img :src="getImageFlag(item.country)" :alt="item.country" style="width: 25px" />
														<a :href="item.url" target="_blank" v-if="item.url" class="ml-2 d-flex" title="Apri l'inserzione su Amazon"
															><img :src="require(`@/assets/images/www.svg`)" :alt="item.url" style="width: 24px"
														/></a>
													</div>
												</template>
												<amazon-seller-fields
													:item="item"
													:currencies="currencies"
													:shipping-items="createListMarketplace(item)"
													@price="changePriceMarketplace"
													@quantity="changeQuantityMarketplace"
													@shipping="changeShippingMarketplace"
													@save="saveOperation"
												/>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna inserzione</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="index">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-sync" @click="chiediEliminaSync(item)">
														<v-list-item-title>Elimina sincronizzazione </v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteMarketplace(item)">
														<v-list-item-title>Elimina da cms/marketplace </v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-edit" v-if="item.status === 'Confirmed'" @click="editConfirmedMarketplace(item)">
														<v-list-item-title>Modifica su cms/marketplace </v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-detail" @click="editItem(item)">
														<v-list-item-title>Visualizza dettaglio prodotto </v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>

										<td>
											{{ item.status }}
										</td>

										<td>
											{{ item.createdDate | moment('DD/MM/YYYY') }}
										</td>

										<td>
											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>

											<!---->
										</td>
										<td class="stack-cell">
											<div v-if="item.item" class="stack-title">{{ item.item }}</div>
											<div v-if="item.sku" class="text-no-wrap"><span class="stack-label">SKU</span> {{ item.sku }}</div>
											<div v-if="item.ean"><span class="stack-label">EAN</span> {{ item.ean }}</div>
											<div v-if="item.qt !== undefined && item.qt !== null">
												<span class="stack-label">Qtà</span> {{ item.qt }}
												<template v-if="item.qtunit"> · <span class="stack-label">Unità</span> {{ item.qtunit }}</template>
											</div>
											<div v-if="formatPrice(item.price)"><span class="stack-label">Prezzo</span> {{ formatPrice(item.price) }} {{ item.currency }}</div>
										</td>
										<td class="stack-cell">
											<div class="d-flex align-center mb-1">
												<img :src="getImageMarketplace(item.platform)" :alt="item.platform" style="width: 30px; margin-right: 5px" />
												<img :src="getImageFlag(item.country)" :alt="item.country" style="width: 25px" />
												<a :href="item.url" target="_blank" v-if="item.url" class="ml-2 d-flex" title="Apri l'inserzione su Amazon"
													><img :src="require(`@/assets/images/www.svg`)" :alt="item.url" style="width: 24px"
												/></a>
											</div>
											<div v-if="item.code"><span class="stack-label">Asin</span> {{ item.code }}</div>
											<div v-if="item.sellerSku" class="text-no-wrap"><span class="stack-label">Seller SKU</span> {{ item.sellerSku }}</div>
										</td>
										<td class="stack-cell amazon-fields">
											<amazon-seller-fields
												:item="item"
												:currencies="currencies"
												:shipping-items="createListMarketplace(item)"
												@price="changePriceMarketplace"
												@quantity="changeQuantityMarketplace"
												@shipping="changeShippingMarketplace"
												@save="saveOperation"
											/>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<v-dialog v-model="dialogconfirmmarketplace" max-width="290">
						<v-card>
							<v-card-title class="headline">Sei sicuro?</v-card-title>
							<v-card-text>Confermando l'operazione il prodotto verra eliminato dal marketplace </v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>

								<v-btn color="primary" text @click="cancelDeleteMarketplace"> Annulla </v-btn>

								<v-btn color="primary" text @click="confirmDeleteMarketplace"> Conferma </v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog v-model="dialogEliminaSync" max-width="380">
			<v-card>
				<v-card-title class="text-h6">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">
					Il prodotto viene scollegato da questa inserzione: la riga sparisce dall'elenco e da qui non la gestisci piu'. L'inserzione su Amazon resta.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="dialogEliminaSync = false">Annulla</v-btn>
					<v-btn color="primary" depressed @click="confermaEliminaSync">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { openWithReturn } from '@/components/core/pageReturn';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { regions as amazonRegions } from '@/utils/amazonPartner';
import CatalogActions from '@/components/marketplace/CatalogActions';
import MarketplaceTabs from '@/components/marketplace/MarketplaceTabs';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createAmazonListTourSteps, stopAmazonListTourMenus } from './amazon-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import AmazonSellerFields from '@/components/marketplace/AmazonSellerFields.vue';
export default {
	name: 'AmazonItems',
	// pagina, righe, ricerca e filtri nell'URL: refresh e ritorno dal dettaglio prodotto ripartono da li'
	mixins: [listRouteState({ filters: { marketplace: 'string', status: 'string' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita' da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createAmazonListTourSteps(), { onStop: stopAmazonListTourMenus }),
		};
	},
	data() {
		return {
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					categories: [],
					brand: {},
					marketplace: '',
					status: '',
				},
				options: {
					sortBy: ['marketplace.data'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,
			dialogEliminaSync: false,
			daEliminareSync: null,
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'status', sortable: false },
				{ text: 'Creazione', value: 'createdDate', sortable: false },
				{ text: 'Immagine', value: 'image', sortable: false },
				{ text: 'Prodotto', value: 'item', sortable: false },
				{ text: 'Amazon', value: 'code', sortable: false },
				{ text: 'Prezzi Amazon', value: 'sellerPrice', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmmarketplace: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			currencies: [],
			form: {
				operations: [],
			},
			menu: false,
			oggettoMarketplace: {},
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		/*fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},*/
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		await this.fetchSetting();
		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		this.currencies = _.filter(this.getSettings.currencies, { is_active: true });
		// stato della lista letto dall'URL in data()
		this.listLoad();
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		CatalogActions,
		MarketplaceTabs,
		TourOverlay,
		KeyValueCard,
		AmazonSellerFields,
	},
	computed: {
		// sotto i 769px (stessa soglia di onResize) le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		imagePlaceholder() {
			return require(`@/assets/images/picture.svg`);
		},
		selectedLength() {
			return this.selected.length;
		},
		marketplaceFilterOptions() {
			return amazonRegions
				.filter(region => region.MarketplaceId && region.marketplace)
				.map(region => ({
					text: region.marketplace,
					value: region.MarketplaceId,
				}));
		},
		statusFilterOptions() {
			return [
				{ text: 'Confirmed', value: 'Confirmed' },
				{ text: 'Void', value: 'Void' },
				{ text: 'Pending', value: 'Pending' },
			];
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'amazon/getIndex',
			getItems: 'amazon/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'amazon/getSortBy',
			getSortDesc: 'amazon/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// stessi dati delle colonne Status/Creazione/Prodotto/Amazon della tabella desktop
		campiCard(item) {
			const qt = item.qt !== undefined && item.qt !== null ? `${item.qt}${item.qtunit ? ' · unità ' + item.qtunit : ''}` : '';
			const prezzo = this.formatPrice(item.price);
			return [
				{ label: 'Status', value: item.status, strong: true },
				{ label: 'Creazione', value: item.createdDate ? this.$moment(item.createdDate).format('DD/MM/YYYY') : '' },
				{ label: 'SKU', value: item.sku },
				{ label: 'EAN', value: item.ean },
				{ label: 'Qtà', value: qt },
				{ label: 'Prezzo', value: prezzo ? `${prezzo} ${item.currency || ''}`.trim() : '' },
				{ label: 'Asin', value: item.code },
				{ label: 'Seller SKU', value: item.sellerSku },
			];
		},
		formatPrice(value) {
			if (value === null || value === undefined || value === '' || isNaN(value)) return '';
			return Number(value).toFixed(3);
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'amazon/setItems',
			setItem: 'items/setItem',
			setIndex: 'items/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'amazon/asyncFetchData',

			destroyData: 'amazon/destroyData',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'amazon/updateData',
			deleteListingItems: 'amazon/deleteListingItems',
			patchListingItems: 'amazon/patchListingItems',
			debugListingItems: 'amazon/debugListingItems',
			setSnackbar: 'settings/updateSnackbar',
			getDetailItem: 'items/getDetailItem',

			//'resetMessages' : 'settings/resetMessages'
		}),
		changePriceMarketplace(item) {
			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'price',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: '',
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		changeShippingMarketplace(item) {
			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'shipping',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: '',
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		deleteSync(item) {
			this.saveOperation({
				platform: item.platform,
				marketplaceId: item.marketplace,
				OperationType: 'deleteSync',
				code: item.code,
				sku: item.sku,
				sellerSku: item.sellerSku,
				_profile: item._profile,
				_entity: item._entity,
				_item: item._item,
				qt: +item.sellerQt,
				price: +item.sellerPrice,
				currency: item.sellerCurrency,
				shipping: item?.shipping ? item.shipping : '',
				extra: '',
				CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
			});
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		chiediEliminaSync(item) {
			this.daEliminareSync = item;
			this.dialogEliminaSync = true;
		},
		confermaEliminaSync() {
			const item = this.daEliminareSync;
			this.dialogEliminaSync = false;
			this.daEliminareSync = null;
			if (item) this.deleteSync(item);
		},
		deleteMarketplace(item) {
			this.dialogconfirmmarketplace = true;
			this.oggettoMarketplace = {
				item,
			};
		},
		cancelDeleteMarketplace() {
			this.dialogconfirmmarketplace = false;
			this.oggettoMarketplace = {};
		},
		async confirmDeleteMarketplace() {
			if (!this.oggettoMarketplace?.item) {
				this.dialogconfirmmarketplace = false;
				return;
			}

			const item = this.oggettoMarketplace.item;
			const country = item.country === 'UK' ? 'GB' : item.country;
			const region = amazonRegions.find(region => region.country_code === country);
			if (!region) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Marketplace Amazon non riconosciuto';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.dialogconfirmmarketplace = false;
				this.oggettoMarketplace = {};
				return;
			}

			const payloadDeleteAmazon = {
				marketplace: region.MarketplaceId,
				sku: item.sellerSku,
			};
			const payloadDeleteCms = {
				platform: item.platform,
				marketplaceId: item.marketplace,
				OperationType: 'delete',
				code: item.code,
				sku: item.sku,
				sellerSku: item.sellerSku,
				_profile: item._profile,
				_entity: item._entity,
				_item: item._item,
				qt: +item.sellerQt,
				price: +item.sellerPrice,
				currency: item.sellerCurrency,
				shipping: item?.shipping ? item.shipping : '',
				extra: '',
				CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
			};

			this.setPreload(true);
			try {
				const { data } = await this.deleteListingItems(payloadDeleteAmazon);
				if (data?.data?.status === 'INVALID') {
					let longMessage = ``;
					for (let message of data.data.issues || []) {
						longMessage += message.message + '<br>';
					}

					if (longMessage) {
						this.snackbar.color = 'error';
						this.snackbar.text = longMessage;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
				}

				if (data?.data?.status === 'ACCEPTED') {
					await this.updateData(payloadDeleteCms);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					await this.getDataFromApi();
				}
			} finally {
				this.setPreload(false);
				this.dialogconfirmmarketplace = false;
				this.oggettoMarketplace = {};
			}
		},
		editItem(item) {
			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			// (la pagina carica da se' il dettaglio del prodotto)
			openWithReturn(this, { path: `/items/${item._item}` }, { label: 'Torna ad Amazon' });
		},
		async editConfirmedMarketplace(item) {
			if (item.status !== 'Confirmed') {
				this.snackbar.color = 'error';
				this.snackbar.text = 'La modifica diretta e disponibile solo per inserzioni Confirmed';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return;
			}

			const country = item.country === 'UK' ? 'GB' : item.country;
			const region = amazonRegions.find(region => region.country_code === country);
			if (!region) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Marketplace Amazon non riconosciuto';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return;
			}

			const payload = {
				marketplace: region.MarketplaceId,
				sku: item.sellerSku,
				productType: 'PRODUCT',
				quantity: +item.sellerQt,
				price: +item.sellerPrice,
				currency: item.sellerCurrency,
			};

			this.setPreload(true);
			try {
				const { data } = await this.patchListingItems(payload);
				if (data?.data?.status === 'INVALID') {
					let longMessage = ``;
					for (let message of data.data.issues || []) {
						longMessage += message.message + '<br>';
					}

					if (longMessage) {
						this.snackbar.color = 'error';
						this.snackbar.text = longMessage;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
				}

				if (data?.data?.status === 'ACCEPTED') {
					await this.debugListingItems(payload);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					await this.getDataFromApi();
				}
			} finally {
				this.setPreload(false);
			}
		},
		async saveOperation(item) {
			this.setPreload(true);
			await this.updateData(item);
			this.setPreload(false);
			this.setSnackbar({ color: 'success', text: 'Operazione effettuata con successo', snackbar: true, mode: 'multi-line', timeout: 5000 }, { root: true });

			this.getDataFromApi();
		},

		createListMarketplace(item) {
			switch (item.platform) {
				case 'Amazon':
					const mws = this.getSettings.settings.find(el => {
						return el.service === 'mws';
					});
					let country = item.country === 'UK' ? 'GB' : item.country;
					if (mws) {
						const shipping = mws.shipping.find(f => {
							return f.country === country;
						});
						if (shipping) {
							return shipping.values;
						} else {
							return [];
						}
					} else {
						return [];
					}
					break;
			}
		},
		changeQuantityMarketplace(item) {
			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'quantity',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: '',
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		imageUrlAlt(index) {
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},
		filterCheck(event) {
			this.settings.filters.categories = _.map(event, '_id');
		},
		createImage(item) {
			try {
				return item.image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;
				//this.items = result.data.data
				this.setPreload(false);
				this.selected = [];
				this.selectedall = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
.stack-cell {
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.stack-title {
	font-weight: 600;
	max-width: 320px;
}
.stack-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	opacity: 0.6;
}
.amazon-fields {
	min-width: 220px;
	padding-top: 8px !important;
	padding-bottom: 8px !important;
}
.amazon-cards tr,
.amazon-cards tr:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.amazon-cards,
.amazon-cards tr {
	display: block;
	width: 100%;
}
.amazon-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.amazon-cards tr:first-child td {
	padding-top: 12px !important;
}
.amazon-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.amazon-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
